import { createClient }from "@sanity/client";

export default createClient({
  projectId: "ykd402m9",
  dataset: "production",
  useCdn: true,
  apiVersion: "2023-02-01"
});